import Tooltip from "@tippyjs/react"

import { FootnoteContent } from "~/screens/ArticlePage/Footnotes/FootnoteContent"
import { getFootnoteId } from "~/utils/articles"

export const FootnoteTooltip: React.FC<{ footnoteNumber: number }> = ({
  footnoteNumber,
}) => {
  const footnoteLink = `#${getFootnoteId(footnoteNumber)}`

  return (
    <Tooltip
      content={
        <FootnoteContent
          linkClass="text-white font-semibold"
          number={footnoteNumber}
        />
      }
      theme="material"
      interactive
    >
      <sup>
        <a href={footnoteLink} onClick={(e) => e.preventDefault()}>
          [{footnoteNumber}]
        </a>
      </sup>
    </Tooltip>
  )
}
